import FaqGut from './FaqGut'

export default FaqGut
